import { Directive, ElementRef, OnDestroy } from '@angular/core';

@Directive({
  selector: 'lord-icon'
})
export class LordIconCleanupDirective implements OnDestroy {
  constructor(private elRef: ElementRef) {}

  ngOnDestroy(): void {
    var el: any = this.elRef.nativeElement;
    try { if (el && typeof el.pause === 'function') el.pause(); } catch(e){}
    try { if (el && typeof el.stop === 'function') el.stop(); } catch(e){}
    try { if (el && typeof el.destroy === 'function') el.destroy(); } catch(e){}
    try {
      var player = null;
      if (el && el.player) player = el.player;
      else if (el && typeof el.getPlayer === 'function') player = el.getPlayer();
      if (player) {
        if (typeof player.pause === 'function') player.pause();
        if (typeof player.stop === 'function') player.stop();
        if (typeof player.destroy === 'function') player.destroy();
      }
    } catch(e){}
    try { if (el && el.parentNode) el.parentNode.removeChild(el); } catch(e){}
  }
}
